export enum Integrations {
  SMARTCO = 'smartCo',
  CATALEAN = 'catalean',
  CONFIGURATOR = 'configurator',
}
